import {
  GraphClassificationFilters,
  GraphExplorerPageSizes,
  GraphGlobalFiltersValues
} from "./@types";

const INIT_PAGE_SIZE = 20; // default to
export const GRAPH_CTRL_NODE = {
  droppedFilesNode: "droppedFilesNode",
  extractedFilesNode: "extractedFilesNode",
  rha1Node: "rha1Node",
  extractedURLsNode: "extractedURLsNode",
  extractedIPsNode: "extractedIPsNode",
  extractedDomainsNode: "extractedDomainsNode",
  contactedURIReferencesNode: "contactedURIReferencesNode",
  contactedDomainReferencesNode: "contactedDomainReferencesNode",
  contactedIPReferencesNode: "contactedIPReferencesNode",
  parentsNode: "parentsNode",
  rootNode: "rootNode"
} as const;

export const CTRL_NODE_LABEL = {
  [GRAPH_CTRL_NODE.droppedFilesNode]: "Dropped Files",
  [GRAPH_CTRL_NODE.extractedFilesNode]: "Extracted Files",
  [GRAPH_CTRL_NODE.rha1Node]: "RHA Similarity",
  [GRAPH_CTRL_NODE.extractedURLsNode]: "Extracted URLs",
  [GRAPH_CTRL_NODE.extractedIPsNode]: "Extracted IPs",
  [GRAPH_CTRL_NODE.extractedDomainsNode]: "Extracted Domains",
  [GRAPH_CTRL_NODE.contactedURIReferencesNode]: "Contacted URLs",
  [GRAPH_CTRL_NODE.contactedDomainReferencesNode]: "Contacted Domains",
  [GRAPH_CTRL_NODE.contactedIPReferencesNode]: "Contacted IPs",
  [GRAPH_CTRL_NODE.parentsNode]: "Parents"
} as const;

export const GRAPH_INIT_PAGE_SIZES: GraphExplorerPageSizes = {
  [GRAPH_CTRL_NODE.droppedFilesNode]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.extractedFilesNode]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.rha1Node]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.extractedURLsNode]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.extractedIPsNode]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.extractedDomainsNode]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.contactedURIReferencesNode]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.contactedDomainReferencesNode]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.contactedIPReferencesNode]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.parentsNode]: {
    pageSize: INIT_PAGE_SIZE
  },
  [GRAPH_CTRL_NODE.rootNode]: {
    pageSize: INIT_PAGE_SIZE
  }
};
export const GRAPH_INIT_GLOBAL_FILTERS: GraphGlobalFiltersValues = {
  classificationFilters: {
    malicious: true,
    suspicious: true,
    goodware: true,
    unknown: true
  } as GraphClassificationFilters,
  fileTypeFilters: {} // dynamically populated
};
export const CTRL_NODE_RADIUS = 60;

export const THREAT_LEVEL_TO_RISK_SCORE_MAP: Record<number, number> = {
  5: 10,
  4: 9,
  3: 8,
  2: 7,
  1: 6,
  0: 0
};

export const NETWORK_RESOURCE_DEFAULT_PAGE_SIZE = 100;

export const WARNING_MESSAGE_TEXT = `Showing only first ${NETWORK_RESOURCE_DEFAULT_PAGE_SIZE} items. For details, navigate to Network Threat Intelligence page.`;

export const CONTROL_NODE_TYPE = {
  FILE_NODE_DETAILS: "file-node-details",
  DROPPED_FILES: "dropped-files",
  EXTRACTED_URLS: "extracted-urls",
  EXTRACTED_IPS: "extracted-ips",
  EXTRACTED_DOMAINS: "extracted-domains",
  CONTACTED_URI_NETWORK_REFERENCES: "contacted-uri-network-references",
  CONTACTED_DOMAIN_NETWORK_REFERENCES: "contacted-domain-network-references",
  CONTACTED_IP_NETWORK_REFERENCES: "contacted-ip-network-references",
  EXTRACTED_FILES: "extracted-files",
  RHA1_GROUP_BY: "rha1-group-by",
  PARENTS: "parents"
};
